import { render, staticRenderFns } from "./simplifyNotepad.vue?vue&type=template&id=ab1bdb7e&scoped=true"
import script from "./simplifyNotepad.vue?vue&type=script&lang=js"
export * from "./simplifyNotepad.vue?vue&type=script&lang=js"
import style0 from "./simplifyNotepad.vue?vue&type=style&index=0&id=ab1bdb7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab1bdb7e",
  null
  
)

export default component.exports